import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './SlideSwitcher.module.css';

interface ILabels {
  first: { title: string; value: string };
  second: { title: string; value: string };
  third: { title: string; value: string };
  fourth: { title: string; value: string };
}

interface IButtonSwitcherProps {
  switchPosition: string;
  setSwitchPosition: (switchPosition: string) => void;
  labels: ILabels;
  searchWord: string;
}

export const ButtonSwitcherFour = ({
  switchPosition,
  setSwitchPosition,
  labels,
  searchWord,
}: IButtonSwitcherProps) => {
  const [animation, setAnimation] = useState<string>('first');
  const location = useLocation();
  
  function getKeyByValue ( obj:ILabels, value:string) {
    return Object.entries(obj).find(([, val]) => val.value === value)?.[0];
  }
  const getSwitchAnimation = (newPosition: string, currentPosition: string) => {
    if (
      newPosition === labels.second.value &&
      currentPosition === labels.first.value
    ) {
      return 'first_to_second';
    } else if (
      newPosition === labels.third.value &&
      currentPosition === labels.second.value
    ) {
      return 'second_to_third';
    } else if (
      newPosition === labels.second.value &&
      currentPosition === labels.third.value
    ) {
      return 'third_to_second';
    } else if (
      newPosition === labels.first.value &&
      currentPosition === labels.second.value
    ) {
      return 'second_to_first';
    } else if (
      newPosition === labels.third.value &&
      currentPosition === labels.first.value
    ) {
      return 'first_to_third';
    } else if (
      newPosition === labels.first.value &&
      currentPosition === labels.third.value
    ) {
      return 'third_to_first';
    }
    else if (
      newPosition === labels.first.value &&
      currentPosition === labels.fourth.value
    ) {
      return 'fourth_to_first';
    } else if (
      newPosition === labels.fourth.value &&
      currentPosition === labels.first.value
    ) {
      return 'first_to_fourth';
    }
    else if (
      newPosition === labels.fourth.value &&
      currentPosition === labels.second.value
    ) {
      return 'second_to_fourth';
    }else if (
      newPosition === labels.second.value &&
      currentPosition === labels.fourth.value
    ) {
      return 'fourth_to_second';
    }else if (
      newPosition === labels.third.value &&
      currentPosition === labels.fourth.value
    ) {
      return 'fourth_to_third';
    }else if (
      newPosition === labels.fourth.value &&
      currentPosition === labels.third.value
    ) {
      return 'third_to_fourth';
    }
    return 'first_to_second';
  };

  const setSwitchAnimation = (value: string) => {
    const animationClass = getSwitchAnimation(value, switchPosition);
    setAnimation(animationClass);
    setSwitchPosition(value);
  };

  const onTagClick = (option: string) => {
    setSwitchPosition(option);
    setSwitchAnimation(option);
  };

  return (
    <div className="flex justify-center">
      <div className="relative hidden lg:inline-block align-middle w-[955px] h-[50px] rounded-3xl bg-cosmith-primary-50">
        <div
          className={`${styles.switch}  ${styles[animation]} ${
            styles[`${getKeyByValue(labels,switchPosition)}_position`]
          }`}
        ></div>
        <NavLink
          to={{
            pathname: location.pathname,
            search: `?${searchWord}=${labels.first.value}`,
          }}
          className={`${styles.label} ${styles.first_label} ${
            getKeyByValue(labels,switchPosition) === 'first' && styles.label_checked
          } focus-outline-custom`}
          onClick={() => onTagClick(labels.first.value)}
        >
          <p className="font-medium leading-6 tracking-[-0.01rem]">
            {labels.first.title}
          </p>
        </NavLink>
        <NavLink
          to={{
            pathname: location.pathname,
            search: `?${searchWord}=${labels.second.value}`,
          }}
          className={`${styles.label} ${styles.second_label} ${
            getKeyByValue(labels,switchPosition) === 'second' && styles.label_checked
          } focus-outline-custom`}
          onClick={() => onTagClick(labels.second.value)}
        >
          <p className="font-medium leading-6 tracking-[-0.01rem]">
            {labels.second.title}
          </p>
        </NavLink>

        <NavLink
          to={{
            pathname: location.pathname,
            search: `?${searchWord}=${labels.third.value}`,
          }}
          className={`${styles.label} ${styles.third_label} ${
            getKeyByValue(labels,switchPosition) === 'third' && styles.label_checked
          } focus-outline-custom`}
          onClick={() => onTagClick(labels.third.value)}
        >
          <p className="font-medium leading-6 tracking-[-0.01rem]">
            {labels.third.title}
          </p>
        </NavLink>
        <NavLink
          to={{
            pathname: location.pathname,
            search: `?${searchWord}=${labels.fourth.value}`,
          }}
          className={`${styles.label} ${styles.fourth_label} ${
            getKeyByValue(labels,switchPosition) === 'fourth' && styles.label_checked
          } focus-outline-custom`}
          onClick={() => onTagClick(labels.fourth.value)}
        >
          <p className="font-medium leading-6 tracking-[-0.01rem]">
            {labels.fourth.title}
          </p>
        </NavLink>
      </div>
    </div>
  );
};
